import React from "react";
import Surface from "./Surface";
import DiamondDivider from "./DiamondDivider";

/**
 * ThemePreview — a throwaway verification screen for Step 1 (foundation).
 * Open the app at "?themepreview=1" to see the §2 tokens, the three fonts,
 * the shared surface (default / hover / active), and the diamond divider on
 * the dark ink background, so it can be compared against
 * design/reference/full-app-dark-theme.html.
 *
 * This is NOT wired into the real app chrome — it will be removed once the
 * real surfaces (sidebar, reading, detail, modal) consume these primitives.
 */
export default function ThemePreview() {
  return (
    <div
      dir="ltr"
      style={{
        minHeight: "100vh",
        background:
          "radial-gradient(1000px 600px at 12% -8%, #1c4433 0%, transparent 58%), var(--ink)",
        color: "var(--parchment)",
        padding: "48px 24px",
      }}
    >
      <div style={{ maxWidth: 820, margin: "0 auto" }}>
        {/* Type specimens */}
        <p
          className="font-cormorant"
          style={{
            textTransform: "uppercase",
            letterSpacing: "3px",
            fontSize: "0.72rem",
            color: "var(--gold-dim)",
            margin: 0,
          }}
        >
          Step 1 · Foundation
        </p>
        <h1
          className="font-cormorant"
          style={{ fontSize: "2.4rem", fontWeight: 600, margin: "4px 0 2px" }}
        >
          Dark theme foundation
        </h1>
        <p
          className="font-amiri"
          dir="rtl"
          style={{ fontSize: "2.6rem", color: "var(--gold-bright)", margin: "0 0 6px" }}
        >
          مراجعة — وَرَحْمَةُ
        </p>
        <p
          className="font-inter"
          style={{ color: "var(--parchment-dim)", fontSize: "0.95rem", margin: 0 }}
        >
          Amiri (Arabic) · Cormorant Garamond (display) · Inter (UI chrome).
        </p>

        <DiamondDivider className="my-8" />

        {/* Shared surface — three states */}
        <p
          className="font-cormorant"
          style={{ textTransform: "uppercase", letterSpacing: "2px", fontSize: "0.7rem", color: "var(--gold-dim)", marginBottom: 12 }}
        >
          The shared surface (§4)
        </p>

        <div style={{ display: "grid", gap: 14 }}>
          <Surface style={{ padding: "16px 18px" }}>
            <div className="font-cormorant" style={{ fontSize: "1.15rem", fontWeight: 600 }}>
              Default surface
            </div>
            <div className="font-inter" style={{ color: "var(--parchment-dim)", fontSize: "0.85rem", marginTop: 4 }}>
              Gradient + gold hairline border.
            </div>
          </Surface>

          <Surface interactive nudge style={{ padding: "16px 18px" }}>
            <div className="font-cormorant" style={{ fontSize: "1.15rem", fontWeight: 600 }}>
              Interactive surface
            </div>
            <div className="font-inter" style={{ color: "var(--parchment-dim)", fontSize: "0.85rem", marginTop: 4 }}>
              Hover: border brightens to gold and nudges 2px.
            </div>
          </Surface>

          <Surface active style={{ padding: "16px 18px" }}>
            <div className="font-cormorant" style={{ fontSize: "1.15rem", fontWeight: 600, color: "var(--gold-bright)" }}>
              Active / selected surface
            </div>
            <div className="font-inter" style={{ color: "var(--parchment-dim)", fontSize: "0.85rem", marginTop: 4 }}>
              Same surface + brighter gold border and ring.
            </div>
          </Surface>
        </div>

        <DiamondDivider className="my-8" />
      </div>
    </div>
  );
}
